import { Tweet } from "react-twitter-widgets"

// We re-export the Tweet component to allow dynamic loading to work properly.
export default Tweet
